<template>
	<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" class="role-dialog" width="550px" :z-index="100">
		<span slot="title" class="dialog-title">
			<span>{{ title }}</span>
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<el-form :model="dataForm" :rules="dataRule" label-width="80px" ref="dataForm">
			<el-form-item label="用户姓名" prop="name">
				<el-input
					size="small"
					v-model="dataForm.name"
					placeholder="请输入姓名"
					maxlength="10"
					@blur="getUserCode"
					:disabled="readonly || usernameFlag"></el-input>
			</el-form-item>
			<el-form-item label="手机号码" prop="tel">
				<el-input size="small" v-model="dataForm.tel" placeholder="请输入手机号" maxlength="11" :disabled="readonly"></el-input>
			</el-form-item>
			<el-form-item label="邮箱地址" prop="email">
				<el-input size="small" v-model="dataForm.email" placeholder="请输入邮箱地址" maxlength="100" :disabled="readonly"></el-input>
			</el-form-item>
			<el-form-item label="用户ID" prop="code">
				<el-input size="small" v-model="dataForm.code" placeholder="建议使用姓名拼音作为用户ID" maxlength="32" :disabled="superAdminFlag"></el-input>
			</el-form-item>
			<el-form-item label="学员ID" prop="stuId">
				<el-input size="small" v-model="dataForm.stuId" placeholder="学员ID" maxlength="32" :disabled="superAdminFlag"></el-input>
			</el-form-item>
			<el-form-item label="所属区域" prop="areaId">
				<el-select size="small" v-model="dataForm.areaId" filterable :disabled="readonly" @change="handleArea">
					<el-option v-for="(item, i) in areaList" :key="i" :value="item.id" :label="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="所属公司" prop="agentId">
				<el-select
					size="small"
					v-model="dataForm.agentId"
					:disabled="readonly"
					ref="comRef"
					@change="handleCompany"
					filterable
					reserve-keyword
					remote
					clearable
					:remote-method="remoteMethod">
					<el-option v-for="(item, i) in dealerList" :key="i" :value="item.id" :label="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="省市" prop="city">
				<el-select size="small" v-model="dataForm.city" filterable placeholder="请选择省市" :disabled="readonly">
					<el-option v-for="item in proviceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="角色选择" prop="roleIdList">
				<el-cascader
					size="small"
					v-model="dataForm.roleIdList"
					class="role-cas"
					:options="roleList"
					:props="{ value: 'id', label: 'name', multiple: true }"></el-cascader>
			</el-form-item>
			<el-form-item label="用户图片" prop="photo" v-if="title == '查看用户' && dataForm.photo">
				<el-image :src="dataForm.photo" fit="scale-down" :preview-src-list="[dataForm.photo]" :append-to-body="true" style="width: 120px; height: 120px;"></el-image>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button class="submit-btn" @click="submit" v-if="title != '查看用户'">确定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from "@/utils/debounce";
import vPinyin from "@/utils/characterToPinYing";
export default {
	data() {
		return {
			title: "新增用户",
			visible: false,
			readonly: false,
			usernameFlag: false,
			areaList: [],
			roleList: [],
			dealerList: [],
			proviceList: [],
			submitUrl: "sysUserAdd",
			dataForm: {
				name: "",
				tel: "",
				email: "",
				code: "",
				stuId: "",
				areaId: "",
				agentId: "",
				city: "",
				roleIdList: [],
				photo: "",
			},
			dataRule: {
				name: [
					{ required: true, message: "用户姓名不能为空", trigger: "blur" },
					{
						pattern:
							/^[A-Za-z0-9\u4e00-\u9fa5\u3400-\u4DBF\uF900-\uFAFF\u20000-\u2A6DF\u2A700-\u2B73F\u2B740-\u2B81F\u2B820-\u2CEAF\u2CEB0-\u2EBEF\.]{1,10}$/,
						message: "请输入中文(包括生僻字)，英文、数字和.",
					},
				],
				tel: [
					{
						pattern: /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/,
						message: "请输入正确手机格式",
					},
				],
				email: [{ pattern: /^[A-Za-z0-9_.-]*([@]+)[A-Za-z0-9_.-]*$/, message: "请输入正确邮箱格式" }],
				code: [{ required: true, message: "请输入用户ID", trigger: "blur" }],
				stuId: [
					{ required: true, message: "学员ID不能为空", trigger: "blur" },
					{ pattern: /^[0-9]*$/, message: "学员ID必选是整数" },
				],
				areaId: [{ required: true, message: "请选择区域", trigger: "change" }],
				agentId: [{ required: true, message: "请选择所属公司", trigger: "change" }],
				city: [{ required: true, message: "请选择省市", trigger: "change" }],
				roleIdList: [{ required: true, message: "请选择角色", trigger: "change" }],
			},
			superAdminFlag: false,
		};
	},
	methods: {
		init(type, data) {
			this.visible = true;
			this.getRoleCas();
			this.$nextTick(() => {
				const userInfo = JSON.parse(window.sessionStorage.userInfo)
				// 网站管理员或超级管理员可以编辑用户名
				this.superAdminFlag = userInfo.adminFlag !== '1' && userInfo.superAdminFlag !== '1'
				this.$refs.dataForm.resetFields();
				this.dataForm.city = "";
				this.proviceList = [];
				if (type == "add") {
					this.getAreaList();
					this.getDealerList();
					this.title = "新增用户";
					this.submitUrl = "sysUserAdd";
					this.readonly = false;
					this.usernameFlag = false;
					delete this.dataForm.id;
					this.getAutoCodeId();
				} else if (type == "edit") {
					this.title = "修改用户";
					this.getUserInfo(data.id);
					this.submitUrl = "sysUserUpdate";
					this.readonly = false;
					this.usernameFlag = this.superAdminFlag;
				} else {
					this.title = "查看用户";
					this.getUserInfo(data.id);
					this.submitUrl = "sysUserUpdate";
					this.readonly = true;
					this.superAdminFlag = true;
				}
			});
		},
		// 获取用户数据
		getUserInfo(id) {
			let that = this;
			that.$request.get(
				"getUserInfo",
				true,
				{
					id: id,
				},
				function (r) {
					if (r.code == "0") {
						that.getDealerList(r.data.agentId, "");
						that.dataForm.id = r.data.id;
						that.dataForm.name = r.data.name;
						that.dataForm.tel = r.data.tel;
						that.dataForm.code = r.data.code;
						that.dataForm.email = r.data.email;
						that.dataForm.stuId = r.data.stuId;
						that.dataForm.agentId = r.data.agentId;
						that.dataForm.areaId = r.data.areaId;
						that.dataForm.city = r.data.city;
						that.getAreaList();
						that.dataForm.roleIdList = r.data.roleCasList;
						that.dataForm.photo = r.data.photo;
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		// 获取角色数据
		getRoleList() {
			let that = this;
			that.$request.get(
				"sysRoleList",
				true,
				{
					name: "",
					type: "",
					pageNo: 1,
					pageSize: 999,
				},
				function (r) {
					if (r.code == "0") {
						that.roleList = r.data.list;
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		// 获取区域数据
		getAreaList() {
			let that = this;
			that.$request.post(
				"getListByCodes",
				true,
				{
					codes: "areaType",
				},
				function (r) {
					if (r.code == "0") {
						const _areaList = [];
						// 去除新增用户时的技术总部选项 2022-08-19
						for (const area of r.data.areaType) {
							if (area.id !== "1399667050993029120") {
								_areaList.push(area);
							}
						}
						that.areaList = _areaList;

						that.areaList.forEach((item) => {
							if (that.dataForm.areaId == item.id) {
								that.proviceList = item.areaList;
							}
						});
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		// 获取省市数据
		handleArea() {
			this.dataForm.agentId = "";
			this.getDealerList();
			this.dataForm.city = "";
			this.areaList.forEach((item) => {
				if (this.dataForm.areaId == item.id) {
					this.proviceList = item.areaList;
				}
			});
		},
		// 获取经销商数据
		getDealerList(dealerId, searchKey) {
			let that = this;
			that.$request.post(
				"getDealerLists",
				true,
				{
					areaId: that.dataForm.areaId,
					searchKey: searchKey,
					dealerId: dealerId,
				},
				function (r) {
					if (r.code == "0") {
						that.dealerList = r.data;
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		// 角色二级下拉
		getRoleCas() {
			let that = this;
			that.$request.get("getRoleCas", true, {}, function (r) {
				if (r.code == "0") {
					// 删除最后一级的children属性
					for (const element of r.data) {
						for (let index = 0; index < element.children.length; index++) {
							const extAttr = element.children[index];
							delete extAttr.children;
						}
					}
					that.roleList = r.data;
				} else {
					that.$message.error(r.msg);
				}
			});
		},
		// 所属公司处理
		handleCompany() {
			this.dealerList.forEach((item) => {
				if (item.id == this.dataForm.agentId) {
					this.dataForm.city = item.city;
				}
			});
		},
		remoteMethod(query) {
			if (query == "") {
				return;
			}
			this.getDealerList(this.dataForm.agentId, query);
		},
		// 获取用户编码
		getUserCode() {
			let code = vPinyin.chineseToPinYin(this.dataForm.name);
			let that = this;
			that.$request.get(
				"sysGetUserCode",
				false,
				{
					code: code,
				},
				function (res) {
					if (res.code == "0") {
						that.dataForm.code = res.data;
					}
				},
			);
		},
		// 获取学员id
		getAutoCodeId() {
			let that = this;
			that.$request.post(
				"getAutoCodeId",
				true,
				{
					code: "stuId",
				},
				function (r) {
					if (r.code == "0") {
						that.dataForm.stuId = r.data.val;
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		// 提交
		submit: debounce(function () {
			if (this.visible == false) {
				return;
			}
			this.$refs["dataForm"].validate((valid) => {
				if (valid) {
					if (this.dataForm.roleIdList.length == 0) {
						this.$message.warning("请选择角色");
						return;
					}
					let that = this;
					const data = JSON.parse(JSON.stringify(that.dataForm));
					let roleIdList = [];
					console.log(data.roleIdList);
					data.roleIdList.forEach((element) => {
						roleIdList.push(element[1]);
					});
					data.roleIdList = roleIdList;
					data.name = data.name.trim();
					that.$request.post(that.submitUrl, true, data, function (r) {
						if (r.code == "0") {
							that.visible = false;
							that.$emit("getUserList");
							that.$message.success("保存成功");
						} else {
							that.$message.error(r.msg);
						}
					});
				} else {
					return false;
				}
			});
		}, 1000),
	},
};
</script>
<style lang="scss" scoped>
.dialog-title {
	display: block;
	text-align: center;
	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}
	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}
.el-form-item {
	margin-bottom: 18px;
	.el-select,
	.el-cascader {
		width: 100%;
	}
}
.submit-btn {
	width: 100%;
	background-color: #117ffc;
	color: #fff;
}
.role-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}
.role-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}

.role-dialog /deep/ .el-dialog__footer {
	padding: 20px 20px 40px !important;
}
.role-cas /deep/ .el-tag__close {
	display: none !important;
}

.el-image-viewer__wrapper {
	z-index: 1000 !important;
}

</style>
